import { cookies, getDomain } from './CookieUtils'

const cookieName = 'localisation-v2'

export function setLocalisationCookie(location, isPermanent = false) {
  const localisationCookie = {
    client: location.client,
  }

  if (location.zip && location.city && location.region) {
    localisationCookie.location = {
      zip: location.zip,
      city: location.city,
      city_addition: location.city_addition,
      region: location.region,
    }
  }
  localisationCookie.isPermanent = isPermanent

  const cookieValue = JSON.stringify(localisationCookie)

  if (isPermanent) {
    cookies.set(cookieName, cookieValue, { expires: 365, path: '/', domain: getDomain(), secure: true })
  } else {
    cookies.set(cookieName, cookieValue, { path: '/', domain: getDomain(), secure: true })
  }
}

export function getLocalisationCookie() {
  const cookie = cookies.get(cookieName)
  if (cookie) return JSON.parse(cookie)

  return null
}

export function removeLocalisationCookie() {
  cookies.remove(cookieName)
}

export function isLocalisationCookiePermanent() {
  const cookie = getLocalisationCookie()
  if (cookie) return cookie.isPermanent

  return false
}
